import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { KpiCards, KpiCardSmallProps, LinkButton, Spinner, Typography } from '@weareopenr/component-library';
import styles from './DashboardWidget.module.scss';

interface DashboardWidgetProps {
  title: string;
  link?: { label: string; to: string };
  isLoading?: boolean;
  emptyCta: ReactNode;
  isEmpty: boolean;
  Kpis?: KpiCardSmallProps[];
  children: ReactNode;
}

export const DashboardWidget = ({
  title,
  link,
  isLoading,
  emptyCta,
  isEmpty,
  Kpis,
  children,
}: DashboardWidgetProps) => {
  const navigate = useNavigate();
  return (
    <div className={styles['widget']} data-testid={`dashboard-widget-${title.toLowerCase().replaceAll(' ', '-')}`}>
      <div className={styles['widget-header']}>
        <div className={styles['widget-title']}>
          <Typography size="large" weight="semi-bold">
            {title}
          </Typography>
        </div>
        {link && <LinkButton onClick={() => navigate(link.to)}>{link.label}</LinkButton>}
      </div>
      {isLoading ? (
        <div className={styles['widget-spinner']}>
          <Spinner size="medium" colour="rainbow" />
        </div>
      ) : (
        renderContent(isEmpty, emptyCta, Kpis, children)
      )}
    </div>
  );
};

export const renderContent = (
  isEmpty: boolean,
  emptyCta: ReactNode,
  Kpis?: KpiCardSmallProps[],
  children?: ReactNode,
) => {
  return (
    <>
      {Kpis && <KpiCards gridSize={2} cards={Kpis} />}
      {isEmpty && emptyCta ? emptyCta : children}
    </>
  );
};
